export const getAgeInversion = (currentAge) =>
  currentAge === "morning" ? "evening" : "morning";
